import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarSimpleLeftSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sidebar-simple-left-square"} maskId="square-filled-radius-0-stroke-1-IconSidebarSimpleLeftSquare"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM9 4V20H20V4H9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSidebarSimpleLeftSquare;
